module.exports = __webpack_public_path__ + "static/media/7.a9a41091.jpg";